import { useState } from 'react'

import statisticsAnalytics from '~/analytics/statistics/statisticsAnalytics'
import { STACK_N_LOAD } from '~/statistics/constants'
import { TreasureTrailProductAPIStat } from '~/statistics/types/stack-n-load.types'

import ProductCardContainer from '../ProductCardContainer'

import TreasureTrailSummary from './TreasureTrailSummary'
import TreasureTrailDetails from './TreasureTrailDetails'

interface Props {
  product: TreasureTrailProductAPIStat
}

export default function TreasureTrailProductCard({ product }: Props): React.ReactElement {
  const [showContent, setShowContent] = useState(false)

  const onToogle = (): void => {
    statisticsAnalytics.logProductCardToggle({ cardName: STACK_N_LOAD, expanded: !showContent })
    setShowContent(!showContent)
  }

  return (
    <ProductCardContainer>
      <TreasureTrailSummary onClick={onToogle} showContent={showContent} timeSpent={product.timeSpent} />
      {showContent && <TreasureTrailDetails product={product} />}
    </ProductCardContainer>
  )
}
